var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-status"},[_vm._v("\n\t"+_vm._s(_vm.patientNo)+" Patients \n\t"),(_vm.action === 'all')?_c('span'):(_vm.action !== 'all' && !_vm.messageName)?_c('span',[_vm._v("\n\t\t- "+_vm._s(_vm.actionName)+"\n\t")]):_c('span',[_vm._v("\n\t\t- '"+_vm._s(_vm.actionName)+"' on '"+_vm._s(_vm.messageName)+"'\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }